export default __webpack_public_path__ + "static/media/education.2fb35aad.jpg";